'use client';
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarItem = void 0;
exports.Sidebar = Sidebar;
exports.SidebarHeader = SidebarHeader;
exports.SidebarBody = SidebarBody;
exports.SidebarFooter = SidebarFooter;
exports.SidebarSection = SidebarSection;
exports.SidebarHeading = SidebarHeading;
exports.SidebarDivider = SidebarDivider;
exports.SidebarSpacer = SidebarSpacer;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("../utils");
// Presentational sidebar primitives. Apps inject their own routing (Next.js
// Link, etc.), active-state logic, icons, and translations — these components
// only define structure + design-system styling.
//
//   <Sidebar>
//     <SidebarHeader>{brand / business switcher}</SidebarHeader>
//     <SidebarBody>
//       <SidebarSection>
//         <SidebarHeading>Sales</SidebarHeading>
//         <SidebarItem href={...} current={...} icon={<PermitsIcon />}>Permits</SidebarItem>
//         ...
//       </SidebarSection>
//       <SidebarDivider />
//       ...
//       <SidebarSpacer />
//     </SidebarBody>
//     <SidebarFooter>{user menu}</SidebarFooter>
//   </Sidebar>
//
// Width: --aiq-sidebar-w (260px). Use `<aside className="w-[260px]">` around
// the <Sidebar> at the layout level, or set the width on Sidebar directly.
function Sidebar(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("nav", Object.assign({}, props, { className: (0, utils_1.cn)('flex h-full min-h-0 flex-col bg-surface', className) }));
}
function SidebarHeader(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, utils_1.cn)('flex h-[65px] items-center border-b border-neutral-100 px-4', className), "data-slot": 'sidebar-header' }));
}
function SidebarBody(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, utils_1.cn)('flex flex-1 flex-col gap-1 overflow-y-auto px-3 pt-3 pb-4', '[&>[data-slot=section]+[data-slot=section]]:mt-5', className), "data-slot": 'sidebar-body' })));
}
function SidebarFooter(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, utils_1.cn)('flex flex-col gap-1 border-t border-neutral-100 p-3', className), "data-slot": 'sidebar-footer' }));
}
function SidebarSection(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, utils_1.cn)('flex flex-col gap-0.5', className), "data-slot": 'section' }));
}
function SidebarHeading(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return ((0, jsx_runtime_1.jsx)("h3", Object.assign({}, props, { className: (0, utils_1.cn)('mb-1 px-3 text-[11px] font-bold uppercase tracking-[0.08em] text-neutral-500', className), children: children })));
}
function SidebarDivider(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("hr", Object.assign({}, props, { className: (0, utils_1.cn)('my-3 border-t border-neutral-100', className) }));
}
function SidebarSpacer(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ "aria-hidden": 'true' }, props, { className: (0, utils_1.cn)('mt-6 flex-1', className) }));
}
// Item styling:
//   resting    neutral-700 text, neutral-400 icons
//   hover      neutral-50 surface, neutral-900 text, neutral-700 icons
//   current    surface-muted background, primary-700 text, primary-500 icon,
//              left rail in primary-500
// Renders <a> when `href` is provided, <button> otherwise. Wrap with Next.js
// `<Link asChild>` etc. at the call site if you need router-aware navigation.
exports.SidebarItem = (0, react_1.forwardRef)(function SidebarItem(props, ref) {
    const _a = props, { current, icon, trailing, className, children } = _a, rest = __rest(_a, ["current", "icon", "trailing", "className", "children"]);
    const classes = (0, utils_1.cn)('group relative flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium transition-colors', 'focus-visible:outline-none focus-visible:shadow-[var(--aiq-ring-focus)]', current
        ? 'bg-surface-muted font-semibold text-primary-700'
        : 'text-neutral-700 hover:bg-neutral-50 hover:text-neutral-900', className);
    const inner = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [current ? (0, jsx_runtime_1.jsx)("span", { "aria-hidden": 'true', className: 'absolute inset-y-1.5 -left-3 w-1 rounded-r-full bg-primary' }) : null, icon ? ((0, jsx_runtime_1.jsx)("span", { "aria-hidden": 'true', className: (0, utils_1.cn)('inline-flex h-4 w-4 shrink-0 items-center justify-center', current ? 'text-primary' : 'text-neutral-400 group-hover:text-neutral-700'), children: icon })) : null, (0, jsx_runtime_1.jsx)("span", { className: 'flex-1 truncate', children: children }), trailing ? (0, jsx_runtime_1.jsx)("span", { className: 'ml-auto inline-flex shrink-0 items-center text-neutral-400', children: trailing }) : null] }));
    if ('href' in props && props.href) {
        const _b = rest, { href } = _b, anchorRest = __rest(_b, ["href"]);
        return ((0, jsx_runtime_1.jsx)("a", Object.assign({}, anchorRest, { "aria-current": current ? 'page' : undefined, className: classes, href: href, ref: ref, children: inner })));
    }
    const buttonRest = rest;
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ type: 'button' }, buttonRest, { "aria-current": current ? 'page' : undefined, className: classes, ref: ref, children: inner })));
});
